// @ts-nocheck
import styled from "@emotion/styled";
import React, { Suspense, useEffect, useState } from "react";
import { DefaultLayout } from "layouts/DefaultLayout";
import axios from "axios";
import { Show } from "components/Show/Show";
import pageElemSVG from "../../assets/svg/pageElem.svg";
import AbstractionSVG from "../../assets/svg/pageElem.svg";
import BgSVG from "../../assets/svg/bg.svg";
import { SuspenseImg } from "components/SuspenseImg/SuspenseImg";
import { NavLink, useParams } from "react-router-dom";
import { Loader } from "components/Loader/Loader";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { LoaderContainer } from "Routes";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  BarElement,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import parse from "html-react-parser";
import { MenuComponent } from "components/Menu/Menu";
import { Link, animateScroll as scroll } from "react-scroll";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  indexAxis: "y" as const,
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      min: 0,
    },
    y: {
      beginAtZero: true,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "right" as const,
    },
    title: {
      display: true,
      text: "",
    },
    datalabels: {
      display: true,
      color: "black",
      anchor: "end",
      align: "end",
      clamp: false,
    },
  },
};

export const options1 = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: "",
    },
    datalabels: {
      display: true,
      color: "black",
      anchor: "end",
      align: "end",
      clamp: false,
    },
  },
  scales: {
    y: {
      type: "linear" as const,
      display: true,
      position: "left" as const,
    },
    y1: {
      type: "linear" as const,
      display: true,
      position: "right" as const,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const Container = styled.div(() => ({
  boxSizing: "border-box",
  padding: "80px",
  position: "relative",
  paddingTop: "50px",
  paddingRight: "80px",
  paddingBottom: "50px",
  display: "flex",
  minHeight: "100vh",
  lineHeight: "30px",
  flexDirection: "column",
  background: "#F3F4F7",
  borderTop: " 20px solid #BF220F",
  paddingTop: 0,
  backgroundImage: `url(${BgSVG})`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  "& a": {
    color: "#0B509F",
    textDecoration: "none",
  },
  "& span": {
    color: "#FF0000",
  },
  "& s": {
    color: "#00742B",
    textDecoration: "none",
    fontWeight: "bold",
  },
  "& b": {
    color: "#234E9A",
  },
}));

const LeftContent = styled.div(() => ({
  width: "60%",
}));

const DefaultBlockTitle = styled.div(() => ({
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "30px",
  color: "#B1321E",
  marginBottom: "12px",
}));

const DefaultBlockTitleSection = styled(DefaultBlockTitle)(() => ({
  marginTop: "20px",
  marginLeft: "70px",
  fontSize: "40px",
}));

const Items = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
}));

const Item = styled.div(() => ({
  width: "30%",
  background: "#FBFCFF",
  boxShadow:
    " 13px 97px 39px rgba(207, 207, 207, 0.01), 7px 55px 33px rgba(207, 207, 207, 0.05), 3px 24px 24px rgba(207, 207, 207, 0.09), 1px 6px 13px rgba(207, 207, 207, 0.1), 0px 0px 0px rgba(207, 207, 207, 0.1)",
  borderRadius: "29px",
  padding: "15px",
  marginBottom: "24px",
  position: "relative",
  height: "150px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  cursor: "pointer",
}));

const PageIMG = styled.img(() => ({
  width: "150px",
  left: 0,
  position: "absolute",
}));

const Abstraction = styled.img(() => ({
  width: "250px",
  right: 0,
  bottom: "-1px",
  transform: "rotate(180deg)",
  position: "absolute",
}));

const PageCount = styled.div(() => ({
  color: "#fff",
  "& span": {
    color: "#fff",
    position: "absolute",
    fontSize: "40px",
    fontWeight: "700",
    left: "30px",
    marginTop: "18px",
  },
}));

const MainContent = styled.div(() => ({
  paddingTop: "20px",
  fontSize: "16px",
}));

const LeftOveriew = styled.div(() => ({
  width: "70%",
}));

const FullText = styled.div(() => ({
  marginTop: "15px",
  marginBottom: "15px",
  width: "100%",
  "& li": {
    listStyle: "none",
    marginBottom: "5px",
    textDecoration: "underline",
    textDecorationColor: "#BF220F",
    textUnderlineOffset: "2px",
    fontSize: "15px",
  },

  "& li::before": {
    content: '"\\2022"',
    color: "#BF220F",
    fontWeight: "bold",
    display: "inline-block",
    width: "1em",
    marginLeft: "-1em",
  },

  "& p": {
    listStyle: "none",
    marginBottom: "5px",
    textDecoration: "underline",
    textDecorationColor: "#BF220F",
    textUnderlineOffset: "2px",
    fontSize: "15px",
    margin: "0px",
  },

  "& p::before": {
    content: '"\\2022"',
    color: "#BF220F",
    fontWeight: "bold",
    display: "inline-block",
    width: "1em",
    marginLeft: "-1em",
  },
}));

const RightList = styled.div(() => ({
  width: "30%",
  "& li": {
    listStyle: "none",
    marginBottom: "5px",
    textDecoration: "underline",
    textDecorationColor: "#BF220F",
    textUnderlineOffset: "2px",
    fontSize: "18px",
  },

  "& li::before": {
    content: '"\\2022"',
    color: "#BF220F",
    fontWeight: "bold",
    display: "inline-block",
    width: "1em",
    marginLeft: "-1em",
  },
}));

const FirstBlock = styled.div(() => ({
  display: "flex",
  gap: "50px",
}));

const colorsForChart = [
  "#65D46E",
  "rgb(255, 99, 132)",
  "#F3D448",
  "#2B62A2",
  "#3478C6",
  "#4734BC",
  "#4468A5",
  "#000000",
];

const strToArray = (str, limit) => {
  const words = str.split(" ");
  let aux = [];
  let concat = [];

  for (let i = 0; i < words.length; i++) {
    concat.push(words[i]);
    let join = concat.join(" ");
    if (join.length > limit) {
      aux.push(join);
      concat = [];
    }
  }

  if (concat.length) {
    aux.push(concat.join(" ").trim());
  }

  return aux;
};

const dataFromArray = (data1, data2, labels) => {
  let datasets;
  let labelsNew = labels;
  if (labels) {
    console.log("labels");
    labelsNew = labels.map((e) => strToArray(e, 50));
  }
  datasets = [
    {
      label: "Average Scores",
      data: data1,
      borderColor: "#BF220F",
      backgroundColor: "#BF220F",
    },
    {
      label: "Your Scores",
      data: data2,
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235)",
    },
  ];
  return {
    labels: labelsNew,
    datasets,
  };
};

const ChartBlock = styled.div(() => ({
  width: "100%",
  margin: "auto",
}));

export default function Report() {
  const [value, setValue] = useState([]);
  const [allIds, setAllIds] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState([]);

  const getRetailDemo = () => {
    setLoading(true);
    axios
      .get("https://osirisfinance.com/api/getReport/2023/")
      .then((response) => {
        setValue(response.data);
        setAllIds(
          response.data.blocks.map((elem) => {
            return {
              id: elem.id,
              name: elem.title,
            };
          })
        );
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getRetailDemo();
  }, []);

  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  const regex = /\\n|\\r\\n|\\n\\r|\\r/g;

  return (
    <>
      <MenuComponent elems={allIds} />
      <Container>
        <DefaultBlockTitle style={{ marginBottom: "20px" }}>
          {" "}
          Individual Report on Organizational Capacity Assessment - 2023
        </DefaultBlockTitle>
        <DefaultBlockTitle style={{ marginBottom: "20px" }}>
          {" "}
          {value.name}
        </DefaultBlockTitle>
        <DefaultBlockTitle style={{ marginBottom: "20px" }}>
          {" "}
          Introduction
        </DefaultBlockTitle>
        <div>
          <p>
            The individual report on the assessment of organizational capacity
            levels was compiled based on a survey of 355 Russian NGOs conducted
            in April-May 2023. This survey was carried out as part of the{" "}
            <a href="https://pulsngo.ru/" target="_blank" class="new-link ">
              «PULSE NGO»
            </a>{" "}
            project, which marks the inaugural long-term and regular study of
            NGOs.{" "}
          </p>
          <p>
            The project is managed by the{" "}
            <a
              href="https://politinst.hse.ru/ccia"
              target="_blank"
              class="new-link "
            >
              Center for Civil Initiatives Assessment at the IAPS NRU HSE
            </a>{" "}
            with financial support from the{" "}
            <a href="https://social.hse.ru/" target="_blank" class="new-link ">
              {" "}
              Faculty of Social Sciences at the NRU HSE{" "}
            </a>{" "}
            and expert backing from the{" "}
            <a
              href="https://nuzhnapomosh.ru/"
              target="_blank"
              class="new-link "
            >
              «Need Help» Foundation
            </a>
            .{" "}
          </p>
          <p>
            The report evaluates the overall level of organizational capacity
            for the surveyed NGOs and provides a specific assessment for your
            organization. This assessment is compared to the general sample of
            NGOs that participated in the study.{" "}
          </p>
          <p>
            The individual report highlights both strengths and weaknesses in
            your NGO's organizational capacity level, along with recommendations
            for enhancing organizational sustainability. By comparing your
            organization's situation to that of other NGOs, you can identify
            achievements and prioritize issues that demand immediate attention.
          </p>
          <p>
            The data from this report can serve as a foundation for discussions
            surrounding your organization's capacity strategy and its potential
            for growth. We recommend that both management and employees acquaint
            themselves with the report, enabling collaborative decisions on how
            the acquired data will be employed in daily operations and which
            organizational processes require heightened focus.{" "}
          </p>
          <p>
            We trust that the information contained in the individual report
            will prove beneficial to your organization. Feel free to direct any
            questions or comments regarding the individual report to{" "}
            <a class="new-link ">pulsngo@gmail.com</a>.
          </p>
          <p>
            This study is conducted annually, the next individual report will
            facilitate the tracking of changes within your organization over the
            year and provide a means to compare these changes with broader
            sectoral trends.
          </p>
        </div>
      </Container>
      <Container>
        <DefaultBlockTitle style={{ marginBottom: "20px" }}>
          {" "}
          Methodology
        </DefaultBlockTitle>
        <div>
          <p>
            The level of organizational capacity of an NGO reflects its
            stability in core organizational processes and establishes its
            ability to effectively achieve&nbsp;its&nbsp;mission. Without
            well-structured strategic planning and proficient financial
            management, coupled with effective management of employees and
            projects, an NPO will encounter challenges in attaining a high
            degree of financial stability or overall organizational
            sustainability.
          </p>
          <p>
            The model of organizational capacity includes{" "}
            <span class="font-bold">12 indicators</span> reflecting the level of
            organizational development in key areas and characteristics of NGOs:
          </p>
          <ol class="row">
            <div class="col">
              <li>Strategy and Planning</li>
              <li>Organizational Management </li>
              <li>Organizational Culture</li>
              <li>Projects and Activities</li>
              <li>Staff </li>
              <li>Volunteers</li>
            </div>
            <div class="col">
              <li>Financial Sustainability</li>
              <li>External Communications</li>
              <li>Advocacy</li>
              <li>Risk Mitigation</li>
              <li>Openness to Change</li>
              <li>Evaluation and Monitoring </li>
            </div>
          </ol>
          <p>
            Risk Mitigation, Openness to Change, and Evaluation and Monitoring
            are cross-cutting&nbsp;indicators. They are based on statements that
            are fundamentally included in other indicators. Each of these three
            components includes all thematic statements related to risks,
            openness or evaluation.
          </p>
          <p>
            Each of the 12 indicators comprises a collection of meaningful
            statements. Respondents evaluated their level of agreement with each
            statement on a 5-point scale. The value of each indicator was
            computed as the average value across all statements encompassed
            within it. An individual average value of the indicator was computed
            for each respondent.
          </p>
          <p>
            To obtain the overall value of the indicator representing the
            surveyed NGOs as a whole, the average value of all individual
            averages was calculated. If a respondent had difficulty responding
            to more than half of the statements included in the indicator, the
            indicator value was not calculated.
          </p>
          <p>
            {" "}
            The final level of organizational capacity is determined by
            calculating the average of the 12 indicators encompassed in the
            assessment model.
          </p>
          <p>
            {" "}
            Differences between your responses and the average responses for the
            surveyed NGOs were calculated based on the 95% confidence interval
            range of the average of each indicator. Statements about whether
            your organization is "above," "below," or "comparable" to the
            surveyed NGOs generally signify statistically significant
            distinctions.
          </p>
          <p>
            For more comprehensive results of the study, an interactive
            presentation can be accessed on the project website at{" "}
            <a href="https://pulsngo.ru/" target="_blank" class="new-link">
              https://pulsngo.ru/
            </a>
            . The website includes a description of the study participant
            sample, an online survey questionnaire, and anonymized online survey
            data.
          </p>
        </div>
      </Container>
      <Container>
        <DefaultBlockTitle style={{ marginBottom: "20px" }}>
          {" "}
          Overall Level of Organizational Capacity of NGOs
        </DefaultBlockTitle>
        <p>
          The level of organizational capacity of NGOs reflects the status of
          the surveyed organizations based on key performance indicators,
          indicating their organizational stability.
        </p>

        <p class="font-bold">
          The overall level of organizational capacity for NGOs is measured at
          3.57 out of 5.
        </p>
        <p>
          <span class="font-bold-black">The strength</span> of NGOs'
          organizational capacity include Organizational Culture (4.14),
          Projects and Activities (4.06), and Openness to Change (3.87). These
          aspects depict NGOs as entities in which individuals who share common
          values collaborate, align with the organization's mission, possess the
          ability to develop and manage projects, and are receptive to feedback.{" "}
        </p>
        <p>
          The areas that receive{" "}
          <span class="font-bold-black">the lowest scores</span> include Staff
          (2.92), Risk Mitigation (2.94), and Financial Sustainability (3.07).
          This indicates that the most significant challenges to the
          sustainability of NGOs encompass insufficient staffing and restricted
          opportunities for staff growth, insufficient funding and financial
          reserves, along with weak risk management.
        </p>
        <FullText>
          {value.overview.summary
            ? parse(value.overview.summary?.replace(regex, "<br>"))
            : ""}
        </FullText>
        <ChartBlock>
          <Line
            plugins={[ChartDataLabels]}
            options={options1}
            data={{
              labels: value.overview.labels,
              datasets: [
                {
                  label: "Average Scores",
                  data: value.overview.data,
                  borderColor: "#BF220F",
                  backgroundColor: "#BF220F",
                },
                {
                  label: "Your Scores",
                  data: value.overview.sample,
                  borderColor: "rgb(53, 162, 235)",
                  backgroundColor: "rgba(53, 162, 235)",
                },
              ],
            }}
          />
        </ChartBlock>
        <div style={{ display: "flex", gap: "20px", maxWidth: "50%" }}>
          <FullText style={{ borderRight: "1px solid #000", width: "55%" }}>
            <span style={{ color: "#BF220F", fontWeight: "700" }}>
              Above average
            </span>
            {value.overview.upper
              ? parse(value.overview.upper?.replace(regex, "<br>"))
              : ""}
          </FullText>
          <FullText>
            <span style={{ color: "#BF220F", fontWeight: "700" }}>
              Below average
            </span>
            {value.overview.lower
              ? parse(value.overview.lower?.replace(regex, "<br>"))
              : ""}
          </FullText>
        </div>
      </Container>

      {value.blocks.map((elem, index) => {
        return (
          <Container id={elem.id}>
            <PageCount>
              <span style={{ zIndex: 10 }}> {index + 1}</span>
              <PageIMG src={pageElemSVG} />
            </PageCount>
            <DefaultBlockTitleSection> {elem.title}</DefaultBlockTitleSection>
            <MainContent>
              <FirstBlock>
                <LeftOveriew>
                  {elem.main_text
                    ? parse(elem.main_text?.replace(regex, "<br>"))
                    : ""}
                </LeftOveriew>
                <RightList>
                  {elem.list ? parse(elem.list?.replace(regex, "<br>")) : ""}
                </RightList>
              </FirstBlock>
              <FullText>
                {elem.main_text_detailed
                  ? parse(elem.main_text_detailed?.replace(regex, "<br>"))
                  : ""}
              </FullText>
              <Show visible={elem.sample_data}>
                <FullText>
                  {elem.personal_text
                    ? parse(elem.personal_text?.replace(regex, "<br>"))
                    : ""}
                </FullText>
                <ChartBlock>
                  <Bar
                    plugins={[ChartDataLabels]}
                    options={options}
                    data={dataFromArray(
                      elem.sample_data,
                      elem.personal_data,
                      elem.personal_data_label
                    )}
                  />
                </ChartBlock>
              </Show>
              <FullText>
                {elem.personal_text_detailed
                  ? parse(elem.personal_text_detailed?.replace(regex, "<br>"))
                  : ""}
              </FullText>
            </MainContent>
            <Abstraction src={AbstractionSVG} />
          </Container>
        );
      })}
    </>
  );
}
